export class TokenStorage {
    static get LOCAL_STORAGE_TOKEN() {
        return '__token';
    }

    static set LOCAL_STORAGE_TOKEN(value) {
        throw new Error(`The LOCAL_STORAGE_TOKEN property cannot be written.`);
    }

    static getAuthentication() {
        return {
            headers: {'Authorization': 'Bearer ' + this.getToken()}
        };
    }

    static storeToken(token) {
        localStorage.setItem(TokenStorage.LOCAL_STORAGE_TOKEN, token);
    }

    static clear() {
        localStorage.removeItem(TokenStorage.LOCAL_STORAGE_TOKEN);
    }

    static getToken() {
        return localStorage.getItem(TokenStorage.LOCAL_STORAGE_TOKEN);
    }
}
